'use client'
import { MembershipBadge, getMembershipBadgeKind, membershipLabelKey } from "@/components/MembershipBadge"
import { useShowPricing } from "@/components/Pricing"
import { useCoinBalance } from "@/hooks/useCoinBalance"
import { useUserDetailStore } from "@/store/useUserDetailStore"
import { Energy } from "@/ui/icons/Energy"
import { Plus } from "@/ui/icons/Plus"
import { Button, cn, useDisclosure } from "@heroui/react"
import { useTranslations } from "next-intl"
import ClaimModal from "../(other)/bonus/_components/ClaimModal"

export default () => {

  const [isVip, vip_type, ad_free] = useUserDetailStore(state => [state.vip, state.vip_type, state.ad_free])
  const { coin } = useCoinBalance()
  const t = useTranslations()

  const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure()

  const showPricing = useShowPricing()
  const badgeKind = getMembershipBadgeKind({ vip: isVip, vipType: vip_type, adFree: ad_free })
  const labelKey = membershipLabelKey(badgeKind)

  return <>
    <Button
      className="bg-gradient-to-r hidden sm:flex from-[#FFBE3F] to-[#FFD74B] text-theme-primary font-bold"
      radius="full"
      onPress={onOpen}
    >{t('bonus.claim')}</Button>
    {
      badgeKind ?
        <Button
          onPress={() => showPricing('premium')}
          className={cn("px-4 justify-start flex gap-[20px] border-0 bg-light-gray",
            "data-[logined=false]:opacity-0",
            "justify-center"
          )}
          radius="full"
          fullWidth>
          <span className="flex items-center" >
            <MembershipBadge vip={isVip} vipType={vip_type} adFree={ad_free} />
            {labelKey && <span className="ml-[6px] font-bold">{t(labelKey)}</span>}
          </span>
        </Button>
        :
        <div className="h-10 flex px-4 rounded-full bg-light-gray  items-center justify-between">
          <Energy />
          <span className="ml-2 text-[14px] leading-[1] font-bold ">{coin}</span>

          <Button
            isIconOnly
            className="ml-5 w-4 h-4 min-w-0 bg-gradient-to-r from-[#FFBE3F] to-[#FFD74B]"
            radius="full"
            size="sm"
            onPress={() => showPricing('energy')} >
            <Plus className="[&_rect]:fill-theme-primary" width={8} />
          </Button>
        </div>
    }

    <ClaimModal onClose={onClose} isOpen={isOpen} onOpenChange={onOpenChange} />

  </>
}
